export const loadGoogleIMAScript = () => {
  const googleIMA = document.getElementById('googleIMAScript');
  if (!googleIMA) {
    const googleIMAScript = document.createElement('script');
    googleIMAScript.setAttribute(
      'src',
      'https://imasdk.googleapis.com/js/sdkloader/ima3.js'
    );
    googleIMAScript.setAttribute('defer', 'defer');
    googleIMAScript.setAttribute('id', 'googleIMAScript');
    document.head.appendChild(googleIMAScript);
  }
};

export const loadGoogleDAIScript = () => {
  const googleDAI = document.getElementById('googleDAIScript');
  if (!googleDAI) {
    const googleDAIScript = document.createElement('script');
    googleDAIScript.setAttribute(
      'src',
      'https://imasdk.googleapis.com/js/sdkloader/ima3_dai.js'
    );
    googleDAIScript.setAttribute('defer', 'defer');
    googleDAIScript.setAttribute('id', 'googleDAIScript');
    document.head.appendChild(googleDAIScript);
  }
};

export const loadVMAXScript = () => {
  const vmaxScript = document.getElementById('vmaxScript');
  const vmaxVideojsPlugin = document.getElementById('vmaxVideojsPlugin');
  if (!vmaxScript) {
    const vmaxAdsScript = document.createElement('script');
    vmaxAdsScript.setAttribute(
      'src',
      'https://stcf-prod.zee5.com/prod/zee5Videojs/vjs/video.min.js'
    );
    vmaxAdsScript.setAttribute('defer', 'defer');
    vmaxAdsScript.setAttribute('id', 'vmaxScript');
    document.head.appendChild(vmaxAdsScript);
  }
  if (!vmaxVideojsPlugin) {
    const vmaxVideojsPlugin = document.createElement('script');
    vmaxVideojsPlugin.setAttribute(
      'src',
      'https://media.zee5.com/prod/VmaxVideoJSPlugin/1.1.0/VmaxVideoJSPlugin.js'
    );
    vmaxVideojsPlugin.setAttribute('defer', 'defer');
    vmaxVideojsPlugin.setAttribute('id', 'vmaxVideojsPlugin');
    document.head.appendChild(vmaxVideojsPlugin);
  }
};
